import { clsx } from "clsx";

interface Props {
  colors: string[];
  maxColors?: number;
  isPreview?: boolean;
  overflowTextClassName?: string;
}

export const ColorOptions = ({ colors, maxColors = 5, isPreview = false, overflowTextClassName }: Props) => {
  return (
    <div className={clsx("flex flex-row pl-1", isPreview ? "cursor-default" : "cursor-pointer")}>
      {colors.slice(0, maxColors).map((color) => (
        <div
          key={color}
          className={
            "ml-[-0.5rem] flex h-[1.25rem] w-[1.25rem] flex-col justify-end " +
            "rounded-full border-2 border-base-input sm:h-[1.5rem] sm:w-[1.5rem]"
          }
          style={{ backgroundColor: color.split("-")[0] }}
        />
      ))}

      {colors.length > maxColors && (
        <div className={clsx("pl-1 text-sm font-bold text-brand-tertiary", overflowTextClassName)}>
          +{colors.length - 1 - maxColors}
        </div>
      )}
    </div>
  );
};
